import { create, StateCreator } from "zustand"
import { DeliveryDashboardMapSlice } from "./store-model"
import { ACTION_MAP } from "../models/model-actions"
import { devtools } from "zustand/middleware"

const createDeliveryDashboardMapSlice: StateCreator<DeliveryDashboardMapSlice, [['zustand/devtools', never]], []> = (set) => ({
    mapCenter: null,
    mapZoomLevel: null,
    restaurantCoordinate: null,
    isMapReFocused: false,
    mapPanOffset: 0,
    setMapCenter: (coordinate: google.maps.LatLngLiteral | null) => set(() => ({ mapCenter: coordinate }), false, ACTION_MAP.SET_CENTER),
    setMapZoomLevel: (zoom: number) => set(() => ({ mapZoomLevel: zoom }), false, ACTION_MAP.SET_ZOOM_LEVEL),
    setMapPanOffset: (panX: number) => set(() => ({ mapPanOffset: panX }), false, ACTION_MAP.SET_PAN_OFFSET),
    setRestaurantCoordinate: (coordinates: google.maps.LatLngLiteral) => set(() => ({ restaurantCoordinate: coordinates }), false, ACTION_MAP.SET_RESTAURANT_COORDINATES),
    setMapReFocusToCenter: (refocus: boolean) => set(() => ({ isMapReFocused: refocus }), false, ACTION_MAP.SET_RESTAURANT_COORDINATES),
    resetZoomLevel: () => set(() => ({ mapZoomLevel: null }), false, ACTION_MAP.RESET_ZOOM_LEVEL)
})

export const useDashboardMapStore = create<DeliveryDashboardMapSlice>()(devtools((...a) => ({
    ...createDeliveryDashboardMapSlice(...a),
}), { name: 'MAP', store: 'map' }))